import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0;
`;

export const ButtonsLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  & > :first-child {
    margin-right: 8px;
  }
  & > :nth-child(2) {
    margin-right: 8px;
  }
  & > button {
    padding: 6px 8px !important;
  }
`;
